import React from "react";
import { InProgress } from "../../App";
import './Competitions.css'

interface Props { }

export default class CompetitionsEvent extends React.Component<Props, any> {
    render() {
        return (
            <div className="container text-center ">
                <img className="sciecnceImg" src="/images/main/science/1.png"></img>
                <a className="d-flex fs-4 padingCom  text-decoration-none" href="/files/Положение о конкурсе Китай.docx">Положение о конкурсе «Путешествие в Поднебесную»</a>
            </div>
        )
    }
}